export const GITHUB_LINK_START_PATH = "/github/link";

export const GITHUB_LINK_GENERIC_ERROR = "Something went wrong. Please try again.";

// Any code not mapped here falls back to GITHUB_LINK_GENERIC_ERROR, so a new/unknown code
// (e.g. `link_failed`) degrades gracefully instead of going blank.
export const GITHUB_LINK_ERROR_MESSAGES: Record<string, string> = {
  already_claimed: "This GitHub account is already linked to another Spacelift user.",
};
